import EmployeeApi from '~/common/api/zeiterfassungServerApi/EmployeeApi';
import { useEmployeesContext, WithEmployeesState } from './state';
import { DeleteTimespanModal } from './DeleteTimespanModal';
import { formatName } from '~/common/utils/employeeUtils';
import { WarningContextProvider } from './WarningContext';
import { ListView } from '~/common/components/ListView';
import { AddEmployeeModal } from './AddEmployeeModal';
import { Divider, Stack } from '@chakra-ui/react';
import { EmployeeHeader } from './EmployeeHeader';
import { EmployeeTile } from './EmployeeTile';
import { Warnings } from './Warnings';
import { useStore } from 'zustand';
import React from 'react';

export const Employees = () => {
  const employeeStore = useEmployeesContext();
  const searchTerm = useStore(employeeStore, (state) => state.searchTerm);
  const [{ data: employees, isLoading }] = EmployeeApi.hooks.useEmployeeQuery();

  return (
    <WarningContextProvider>
      <Warnings />
      <AddEmployeeModal />
      <DeleteTimespanModal />
      <EmployeeHeader />
      <ListView
        data={employees ?? []}
        searchFields={(e) => [
          e.user.first_name,
          e.user.last_name,
          e.user.first_name + ' ' + e.user.last_name,
          e.user.last_name + ' ' + e.user.first_name,
        ]}
        search={searchTerm}
        orderBy={formatName}
        isLoading={isLoading}
        render={({ data }) => {
          return (
            <Stack mt={10}>
              {data.map((employee) => (
                <React.Fragment key={employee.id}>
                  <EmployeeTile employee={employee} />
                  <Divider />
                </React.Fragment>
              ))}
            </Stack>
          );
        }}
      />
    </WarningContextProvider>
  );
};
export const EmployeesV2 = () => (
  <WithEmployeesState>
    <Employees />
  </WithEmployeesState>
);
